import React from 'react';

export default ({ ...props }) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <title>Zoom</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 11a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-1.094 6.32a8 8 0 1 1 1.414-1.414l3.387 3.387a1 1 0 0 1-1.414 1.414l-3.387-3.387ZM12 12v3h-2v-3H7v-2h3V7h2v3h3v2h-3Z"
      fill="#4d5559"
    />
  </svg>
);
